<template>
  <div class="app-container pull-auto news-news-list">
    <div class="news-news-list-filter">
      <el-row>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <label class="news-news-list-filter-label">来源名称</label>
            <el-input class="news-news-list-filter-value" v-model="search.name" clearable size="small"></el-input>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <label class="news-news-list-filter-label">爬取状态</label>
            <el-select class="news-news-list-filter-value" placeholder="" v-model="search.selectedIsActive" clearable size="small">
              <el-option
                v-for="item in search.isActive"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <label class="news-news-list-filter-label">展示结果</label>
            <el-select class="news-news-list-filter-value" placeholder="" v-model="search.selectedIsDisplay" clearable size="small">
              <el-option
                v-for="item in search.isDisplay"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </el-col>
        <div>
          <el-button class="news-news-list-filter-button1" size="small" @click="searchReset">清空</el-button>
          <el-button class="news-news-list-filter-button2" type="primary" size="small" @click="searchChange">搜索</el-button>
        </div>
      </el-row>
    </div>
    <basic-container class="news-news-list-container">
      <avue-crud ref="crud"
        :page="page"
        :data="tableData"
        :table-loading="tableLoading"
        :option="sourceTableOption"
        @current-change="currentChange"
        @refresh-change="refreshChange"
        @size-change="sizeChange">

        <template slot="isActive2"
                  slot-scope="scope">
          <el-switch v-model="scope.row.isActive2"
                     active-color="#00A854"
                     inactive-color="#F04134"
                     @change="handleIsActiveUpdate(scope.row,scope.index)">
          </el-switch>
        </template>
        <template slot="isDisplay2"
                  slot-scope="scope">
          <el-switch v-model="scope.row.isDisplay2"
                     active-color="#00A854"
                     inactive-color="#F04134"
                     @change="handleIsDisplayUpdate(scope.row,scope.index)">
          </el-switch>
        </template>
        <template slot="menu"
            slot-scope="scope">
            <el-button size="mini"
                type="text"
                icon="el-icon-view"
                @click="handleView(scope.row,scope.index)">查看
            </el-button>
            <el-button size="mini"
                type="text"
                icon="el-icon-edit"
                @click="handleUpdate(scope.row)">编辑
            </el-button>
        </template>
      </avue-crud>
    </basic-container>
  </div>
</template>

<script>
  import { getSourceListPage, getSource, updateSource } from '@/api/news/source'
  import { sourceTableOption } from '@/const/crud/news/list'
  import { mapGetters } from 'vuex'
  export default {
    name: 'source',
    data() {
      return {
        search: {
          name: "",
          selectedIsDisplay: null,
          isDisplay: [
            { label: '否', value: 0 },
            { label: '是', value: 1 }
          ],
          selectedIsActive: null,
          isActive: [
            { label: '关闭', value: 0 },
            { label: '开启', value: 1 }
          ],
        },
        tableData: [],
        page: {
          total: 0, // 总页数
          currentPage: 1, // 当前页数
          pageSize: 20 // 每页显示多少条
        },
        listQuery: {
          current: 1,
          size: 20,
          sortField: "",
          sortPolicy: ""
        },
        tableLoading: false,
        sourceTableOption: sourceTableOption,
        activeName: "first",
      }
    },
    created() {
      this.getList()
    },
    mounted: function() { },
    computed: {

    },
    methods: {
      formateData(records) {
        records.forEach(function(record, index) {
          if (record.type == 1) {
            record.sourceType = "网站"
          } else if (record.type == 2) {
            record.sourceType = "微信公众号"
          } else if (record.type == 3) {
            record.sourceType = "微博"
          } else if (record.type == 4) {
            record.sourceType = "其它"
          } else {
            record.sourceType = "--"
          }
          record.isActive2 = record.isActive == 1
          record.isDisplay2 = record.isDisplay == 1
        })
        return records
      },
      getList() {
        let params = {
          current: this.listQuery.current,
          size: this.listQuery.size
        }

        // 添加筛选条件
        if (this.search.name != '' && this.search.name.trim() != '') {
          params.name = this.search.name.trim()
        }

        if (this.search.selectedIsActive != null) {
          params.isActive = this.search.selectedIsActive
        }

        if (this.search.selectedIsDisplay != null) {
          params.isDisplay = this.search.selectedIsDisplay
        }

        // 添加排序
        if (this.listQuery.sortField != "" && this.listQuery.sortPolicy != "") {
          params.sortField = this.listQuery.sortField
          params.sortPolicy = this.listQuery.sortPolicy
        }

        this.tableLoading = true
        getSourceListPage(params).then(response => {
          this.tableData = this.formateData(response.data.data.records)
          this.page.total = response.data.data.total
          this.tableLoading = false
        })
      },
      initPage() {
        this.listQuery = {
          current: 1,
          size: 20,
          sortField: "",
          sortPolicy: ""
        }
      },
      searchChange() {
        this.initPage()
        this.getList()
      },
      searchReset() {
        this.search.name = ""
        this.search.selectedIsActive = null
        this.search.selectedIsDisplay = null
        this.searchChange()
      },
      currentChange(val) {
        this.page.currentPage = val
        this.listQuery.current = val
        this.getList()
      },
      sizeChange(val) {
        this.page.pageSize = val
        this.page.currentPage = 1
        this.listQuery.size = val
        this.listQuery.current = 1
        this.getList()
      },
      handleView(row, index) {
        if (row.id) {
          this.activeName = "first"
          this.$router.push({
              path: `/news/source/detail/${row.id}`
          })
        } else {
          this.$message({
            showClose: true,
            message: '无效来源',
            type: 'warning'
          })
        }
      },
      handleUpdate(row) {
        let _this = this
        this.$router.push({
          path: `/news/source/detail/${row.id}`,
          query: { edit: 'true' }
        })
      },
      /**
      * 刷新回调
      */
      refreshChange() {
        this.getList()
      },
      handleIsActiveUpdate(row, index){
        if (row.id){
          if (row.isActive2) {
            row.isActive = 1
          } else {
            row.isActive = 0
          }
          let obj = {
            id: row.id,
            isActive: row.isActive
          }
          updateSource(obj);
        } else {
          this.$message({
            showClose: true,
            message: '该来源不存在',
            type: 'warning'
          })
        }
      },
      handleIsDisplayUpdate(row, index){
        if (row.id){
          if (row.isDisplay2) {
            row.isDisplay = 1
          } else {
            row.isDisplay = 0
          }
          let obj = {
            id: row.id,
            isDisplay: row.isDisplay
          }
          updateSource(row);
        } else {
          this.$message({
            showClose: true,
            message: '该来源不存在',
            type: 'warning'
          })
        }
      }

    }
  }
</script>

<style lang="scss" scoped>
.news-news-list {
  &-filter {
    margin: 0px 10px;
    background-color: #fff;
    padding-top: 20px;
    padding-left: 22px;

    &-label {
      font-size: 14px;
      color: #606266;
      margin-right: 7px;
    }

    &-value {
      width: calc(100% - 70px) !important;
    }

    &-date {
      width: calc(100% - 131px) !important;
    }

    &-button1 {
      float: right;
      margin-right: 35px;
    }

    &-button2 {
      float: right;
      margin-right: 10px;
    }
  }

  &-container {
    padding-top: 0px;
  }
}
</style>

